// Default time window values in minutes from midnight
export const DEFAULT_HOURS_SLIDER_VALUE = [540, 1260]; // 9 AM to 9 PM

// Default minimum window in minutes
export const DEFAULT_MINIMUM_WINDOW = 15;

// Timing options for when canvassers are needed
export const TIMING_OPTIONS = [
  { value: 'asap', label: 'I need canvassers as soon as possible' },
  { value: 'future', label: 'I need canvassers in the future' },
];

// Timeframe options for scheduling
export const TIMEFRAME_OPTIONS = [
  { value: 'anytime', label: 'This job can happen anytime between 9am and 9pm local' },
  { value: 'custom', label: 'Custom window' },
];

// Timezone options
export const TIMEZONE_OPTIONS = [
  { value: 'LOCAL', label: 'Local Relative to Contact' },
  { value: 'US/Eastern', label: 'Eastern Time' },
  { value: 'US/Central', label: 'Central Time' },
  { value: 'US/Mountain', label: 'Mountain Time' },
  { value: 'US/Pacific', label: 'Pacific Time' },
];

// Validation messages
export const VALIDATION_MESSAGES = {
  NOT_ENOUGH_LEADS:
    'You need at least 20 leads remaining to schedule initial canvassers.',
  JOB_PAUSED: 'Cannot schedule canvassers while job is paused.',
  JOB_ERROR: 'Cannot schedule canvassers while job has errors.',
  DELIVERABILITY_ERROR: 'Cannot schedule canvassers due to deliverability check errors.',
  NO_AGENTS: 'Cannot schedule canvassers without assigned agents.',
  ACCOUNT_PERMISSION:
    'Your account does not have permission to schedule initial canvassers.',
};
